/** Título de pestaña de una ruta: «X | InboMarket», o «InboMarket» si no tiene. */
export const tituloDeRuta = (title?: string): string =>
  title ? `${title} | InboMarket` : 'InboMarket';
